/**
 * 菜单管理 API
 */

import { http } from '../request';
import type { Menu } from '../../types/menu';

/**
 * 获取当前用户菜单树（用于侧边栏）
 */
export function getCurrentUserMenuTree(): Promise<Menu[]> {
  return http.get<Menu[]>('/system/menu/tree');
}

/**
 * 获取所有菜单树（用于角色权限分配）
 */
export function getAllMenuTree(): Promise<Menu[]> {
  return http.get<Menu[]>('/system/menu/tree/all');
}

/**
 * 查询菜单列表
 */
export function getMenuList(): Promise<Menu[]> {
  return http.get<Menu[]>('/system/menu/list');
}

/**
 * 根据 ID 查询菜单详情
 */
export function getMenuById(id: number): Promise<Menu> {
  return http.get<Menu>(`/system/menu/${id}`);
}

/**
 * 创建菜单
 */
export function createMenu(data: Menu): Promise<void> {
  return http.post('/system/menu', data);
}

/**
 * 更新菜单
 */
export function updateMenu(id: number, data: Menu): Promise<void> {
  return http.put(`/system/menu/${id}`, data);
}

/**
 * 删除菜单
 */
export function deleteMenu(id: number): Promise<void> {
  return http.delete(`/system/menu/${id}`);
}
